export const question_factors = (state) => state.factors
